// extracted by mini-css-extract-plugin
module.exports = {"root":"ComparisonSlider_root__EEPfT"};